import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { JoinCostCenterCostUnitDialogModule } from './join-cost-center-cost-unit-dialog/join-cost-center-cost-unit-dialog.module';
import { CellEditorModule, GenericInputModule } from '@sla-ng/ui-material';
import { JoinCostCenterCostUnitPage } from './join-cost-center-cost-unit.page';
import { TransferCostCenterCostUnitDialogModule } from './transfer-cost-center-cost-unit-dialog/transfer-cost-center-cost-unit-dialog.module';


export * from './join-cost-center-cost-unit.page';
export * from './join-cost-center-cost-unit-dialog/join-cost-center-cost-unit-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: JoinCostCenterCostUnitPage,
    },
];

@NgModule({
    declarations: [ JoinCostCenterCostUnitPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatSelectModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        CellEditorModule,
        FormsModule,
        MatSortModule,
        TranslateModule,
        MatAutocompleteModule,
        MatMomentDateModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        MatTooltipModule,
        GenericInputModule,
        JoinCostCenterCostUnitDialogModule,
        TransferCostCenterCostUnitDialogModule
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ]
})
export class JoinCostCenterCostUnitPageModule {
}
